module.exports = __webpack_public_path__ + "static/getStarted_chronic-6d5408ad654a13e5e0d7d7693a999745.svg";